@if (isNativePlatform) {
  <zwi-top-spacer></zwi-top-spacer>
}
<div class="zwi-simple-page-body">
  <div class="zwi-simple-page-header">
    <a routerLink="/home" style="line-height: 1;">
      <img src='assets/img/landing-logo.png' alt="Zwiloo" class="zwi-logo"/>
    </a>
  </div>
  <div class="zwi-page-content">
    <ng-content></ng-content>
  </div>
</div>
